import { c as _c } from "react/compiler-runtime";
import { sentryCaptureError } from "@utils/sentry-utils";
import { createContext, use } from "react";
const CompanyIdContext = createContext(null);
/**
 * Provides a guaranteed non-null companyId to the subtree.
 * Must be rendered inside a boundary that already validated companyId exists
 * (e.g. SdbCompanyLoader).
 */
export function CompanyIdProvider(t0) {
  const $ = _c(3);
  const {
    companyId,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== companyId) {
    t1 = <CompanyIdContext value={companyId}>{children}</CompanyIdContext>;
    $[0] = children;
    $[1] = companyId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/**
 * Returns the current companyId. Guaranteed to be a non-null string.
 * Can only be used inside routes wrapped by CompanyIdProvider (i.e. inside /:companyId).
 *
 * This is the primary way to access companyId in components — prefer this over
 * `useAppParams().companyId` or `useAppSelector(selectedSdbCompanyIdSelector)`.
 */
export function useCompanyId() {
  const companyId = use(CompanyIdContext);
  if (!companyId) {
    const error = new Error("useCompanyId() called outside <CompanyIdProvider>. " + "Use useAppParams() instead for components that render outside /:companyId routes.");
    sentryCaptureError({
      error,
      title: "useCompanyId() called outside CompanyIdProvider"
    });
    throw error;
  }
  return companyId;
}